<!--
 * @Author: mazhigang
 * @Date: 2023-09-10 15:27:44
 * @LastEditors: mazhigang
 * @LastEditTime: 2023-10-28 16:52:57
-->
<template>
  <div style="background: #FAFCFF;overflow-x: scroll;">
    <div class="pageTop">
      <div class="topBox">
        <pageTop :color="'#000'"></pageTop>
      </div>
    </div>
    <div style="padding-top: 65px;box-sizing: border-box;">
      <div class="topBanner">
        <img src="../../../static/userBanner.png" alt="" style="width: 100%;" />
        <div style="position: absolute;top: 50px;left: 28%;">
          <div style="font-size: 28px;font-weight: bold;">咖德App产品介绍</div>
          <div class="solid"></div>
          <div style="font-size: 16px;">海量保安任您选，智能匹配更高效</div>
        </div>
      </div>
      <div>
        <!-- <div class="boxTitle">
          <img
            src="../../../static/titleIcon.png"
            alt=""
            style="width: 31px;height: 25px;z-index: 1;margin-right: 10px;margin-top: 4px;"
          />
          <div>咖德App产品介绍</div>
        </div> -->
        <div class="swiperBox">
          <div style="overflow: hidden;">
            <div style="display: flex;align-items: center;margin-top: 88px;">
              <img
                src="../../../static/userLogo.png"
                alt=""
                style="width: 76px;height: 76px;margin-right: 16px;"
              />
              <div>
                <div style="font-size: 22px;font-weight: bold;">咖德</div>
                <div style="font-size: 16px;color: #545D80;">
                  海量保安任您选，智能匹配更高效
                </div>
              </div>
            </div>
            <div style="width: 575px;margin-left: 103px;margin-top: 24px;">
              <div class="accordion">
                <div
                  v-for="(item, index) in list"
                  :key="index"
                  :class="[
                    'accordion-item',
                    activeIndex === index ? 'activeBg' : ''
                  ]"
                  @click="toggle(index)"
                >
                  <div class="title">
                    <img
                      v-if="index != activeIndex"
                      src="../../../static/rightFlo.png"
                      alt=""
                      style="width:8px;height: 8px;margin-right: 14px;"
                    />
                    <img
                      v-if="index == activeIndex"
                      src="../../../static/downFlo.png"
                      alt=""
                      style="width:8px;height: 8px;margin-right: 14px;"
                    />
                    {{ item.title }}
                  </div>
                  <div class="content" :class="{ open: activeIndex === index }">
                    {{ item.info }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style="margin-top: 50px;margin-right: 110px;position: relative;">
            <div class="carousel" style="width: 254px;">
              <!-- 图片轮播区域 -->
              <div class="carousel-inner" :style="carouselInnerStyle">
                <div
                  v-for="(image, index) in images"
                  :key="index"
                  class="carousel-item"
                  :style="itemStyle(index)"
                >
                  <img
                    :src="image"
                    alt="Carousel Image"
                    style="width: 100%; height: 543px; object-fit: cover;"
                  />
                </div>
              </div>
              <!-- 进度条指示器 -->
            </div>
            <div class="indicators" v-if="images.length > 1">
              <div
                v-for="(image, index) in images"
                :key="index"
                class="indicator"
              >
                <div style="width: 50px;margin-right: 10px;">
                  <el-progress
                    :show-text="false"
                    :percentage="imageProgress[index]"
                    :color="'rgba(16, 95, 255, 1)'"
                  ></el-progress>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="infoBox">
        <div class="boxTitle">
          <img
            src="../../../static/titleIcon.png"
            alt=""
            style="width: 31px;height: 25px;z-index: 1;margin-right: 10px;margin-top: 4px;"
          />
          <div>咖德保安对保安公司/人力中介的价值</div>
        </div>
        <div class="boxContent">
          <!-- <div class="TitleBox">
            <div class="titleItem">个人安保服务</div>
            <div class="titleItem">家庭安保</div>
            <div class="titleItem">活动安保</div>
            <div class="titleItem">随身护卫</div>
          </div> -->
          <div class="itemBox">
            <div
              class="infoItem"
              v-for="(item, index) in infoList"
              :key="index"
            >
              <img :src="item.image" alt="" />
              <div>
                <div class="title1">{{ item.title }}</div>
                <div class="info1">
                  {{ item.info }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="infoBox1">
        <div class="boxTitle">
          <img
            src="../../../static/titleIcon.png"
            alt=""
            style="width: 31px;height: 25px;z-index: 1;margin-right: 10px;margin-top: 4px;"
          />
          <div>咖德保安对企业用户的价值</div>
        </div>
        <div class="boxContent">
          <div class="TitleBox">
            <div class="titleItem">企业安保解决方案</div>
            <div class="titleItem">保安外包服务</div>
            <div class="titleItem">临时安保招聘</div>
            <div class="titleItem">长保临时替补</div>
          </div>
          <div class="itemBox">
            <div
              class="infoItem"
              v-for="(item, index) in infoList1"
              :key="index"
            >
              <img :src="item.image" alt="" />
              <div>
                <div class="title1">{{ item.title }}</div>
                <div class="info1">
                  {{ item.info }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </div>
    <pagebottom></pagebottom>
    <pageleft></pageleft>
  </div>
</template>
<script>
import pageTop from "../../components/pageTitle.vue";
import pageleft from "../../components/leftCode.vue";
import pagebottom from "../../components/pagebottom.vue";
export default {
  components: {
    pageTop,
    pageleft,
    pagebottom
  },
  data() {
    return {
      activeIndex: 0,
      list: [
        {
          title: "快速发岗招保安",
          info:
            "一键发布保安岗位，自定义薪资与结算方式，灵活配置岗位信息与招聘要求。",
          img: [
            "../../../static/banner1.png",
            "../../../static/banner2.png",
            "../../../static/banner3.png"
          ]
        },
        {
          title: "便捷管理招聘岗位",
          info:
            "岗位列表清晰，实时查看报名人数，灵活操作岗位启停与修改，告别招聘岗位管理混乱。",
          img: ["../../../static/banner4.png"]
        },
        {
          title: "支持一键电话沟通",
          info:
            "岗位报名信息及时推送，可查看应聘人员列表，一键电话联系沟通更高效。",
          img: ["../../../static/banner5.png", "../../../static/banner6.png"]
        },
        {
          title: "VIP招保安，快人一步",
          info:
            "开通会员即可不限次数发布岗位、电话沟通，搭配专属服务与企业标识，助力企业快速完成保安招聘。",
          img: ["../../../static/banner7.png"]
        }
      ],
      currentIndex: 0,
      images: [],
      intervalId: null,
      slideDuration: 5000, // 每张图片展示的时间，单位为毫秒
      imageProgress: [],
      infoList: [
        {
          image: "../../../static/info2.png",
          title: "招人更快，缩短缺岗周期",
          info:
            "只做保安行业招聘，平台聚集了大量想找保安工作、消防中控工作的求职者，覆盖长保、临勤业务，支持月结、日结等多种结算模式，解决保安行业“流失快、补人急”的痛点。"
        },
        {
          image: "../../../static/info3.png",
          title: "降低招聘成本",
          info:
            "用工方不用跑劳务市场，摆脱高价劳务报酬，平台直连，降低层层转包成本。"
        },
        {
          image: "../../../static/info7.png",
          title: "提高招聘效率",
          info:
            "保安员基础资质线上可见，可在App内查看求职者年龄、身高、是否有保安证等基础信息，减少无效面试。"
        },
        {
          image: "../../../static/info6.png",
          title: "提升岗位管理效率",
          info:
            "用工方秒发岗位，通过智能算法匹配推给求职者，应聘者列表清晰科可见，不用微信杂乱翻记录。"
        }
      ],
      infoList1: [
        {
          image: "../../../static/info5.png",
          title: "定制化安保方案",
          info:
            "针对商业地产、工业厂区、大型活动、跨区域多项目等不同场景，提供专属安保解决方案，适配企业个性化需求"
        },
        {
          image: "../../../static/info6.png",
          title: "降本增效提效率",
          info:
            "通过智能匹配系统快速调配安保人员，减少人力闲置成本；线上管理安保团队、查看服务数据，提升管理效率"
        },
        {
          image: "../../../static/info7.png",
          title: "合规专业降风险",
          info:
            "保安人员持证服务，平台提供服务协议、资质备案、责任保险等合规支持，规避企业用工风险与安保服务纠纷"
        },
        {
          image: "../../../static/info8.png",
          title: "数字化管理可视化",
          info:
            "依托智慧安保管理平台，实时查看安保人员位置、巡逻轨迹等，生成数据报表，管理更透明、决策更科学"
        }
      ]
    };
  },
  mounted() {
    this.images = this.list[this.activeIndex].img;
    this.resetImageProgress();
    this.startAutoPlay();
  },
  beforeDestroy() {
    this.stopAutoPlay();
  },
  computed: {
    carouselInnerStyle() {
      return {
        transform: `translateX(-${this.currentIndex * 100}%)`
      };
    }
  },
  methods: {
    resetImageProgress() {
      this.imageProgress = new Array(this.images.length).fill(0);
    },
    toggle(index) {
      this.stopAutoPlay(); // 停止旧定时器
      this.resetImageProgress();
      this.activeIndex = index;
      this.images = this.list[this.activeIndex].img || [];
      this.currentIndex = 0;

      this.$nextTick(() => {
        if (this.images.length > 0) {
          this.startAutoPlay();
        }
      });
    },
    itemStyle(index) {
      const offset = index - this.currentIndex;
      return {
        transition: `transform 0.5s ease`,
        transform: `translateX(${offset * 100}%)`
      };
    },
    startAutoPlay() {
      this.stopAutoPlay();

      // 每张图的播放周期独立控制
      const playCurrent = () => {
        let elapsed = 0;
        const step = 10; // 每10ms更新一次
        const total = this.slideDuration;

        // 重置当前图进度为 0
        this.$set(this.imageProgress, this.currentIndex, 0);

        const progressTimer = setInterval(() => {
          elapsed += step;
          const percent = Math.min(100, (elapsed / total) * 100);
          this.$set(this.imageProgress, this.currentIndex, percent);
          if (elapsed >= total) {
            clearInterval(progressTimer);
            this.resetImageProgress();
            this.next(); // 切换下一张
          }
        }, step);

        this.intervalId = progressTimer; // 用于清理
      };

      // 立即开始第一张
      playCurrent();

      // 监听 currentIndex 变化（通过 next 触发下一张）
      // 注意：我们不再用 setInterval(next, duration)，而是靠 progress 完成后手动调 next
    },

    stopAutoPlay() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    },
    next() {
      if (this.images.length <= 1) return;

      this.currentIndex = (this.currentIndex + 1) % this.images.length;

      // 自动开始下一张的进度条
      this.$nextTick(() => {
        this.startAutoPlay(); // 重新启动（会清理上一个 timer 并启动新的）
      });
    },
    goToSlide(index) {
      this.currentIndex = index;
    }
  }
};
</script>
<style scoped>
@media (max-width: 1920px) {
  .swiperBox {
    transform: scale(0.9);
  }
}
.topBox {
  width: 100%;
  background: #fff;
  box-shadow: 0px 2px 4px 0px rgba(155, 155, 155, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
}
.topBanner {
  width: 100%;
  position: relative;
}
.solid {
  width: 72px;
  height: 6px;
  background: linear-gradient(270deg, rgba(238, 238, 238, 0) 0%, #4b74fe 100%);
  border-radius: 3px;
  margin: 14px 0 14px 0;
}
.boxTitle {
  font-size: 25px;
  font-weight: bold;
  color: #00122c;
  line-height: 29px;
  display: flex;
  align-content: center;
  justify-content: center;
}
.boxTitle img {
  z-index: -1;
}
.swiperBox {
  width: 1200px;
  margin: 16px auto;
  box-sizing: border-box;
  height: 680px;
  background-image: url("../../../static/swiperBg.png");
  background-size: 100% 100%;
  display: flex;
  justify-content: space-between;
}

.accordion {
  width: 100%;
  max-width: 600px;
  margin: 20px auto;
}

.accordion-item {
  cursor: pointer;
}
.activeBg {
  background: linear-gradient(
    180deg,
    #ffffff 0%,
    rgba(255, 255, 255, 0.21) 100%
  );
  border-radius: 8px;
}

/* 标题样式 */
.title {
  display: flex;
  align-items: center;
  padding: 16px 12px;
  font-size: 16px;
  font-weight: 500;
  color: #333;
}

/* 内容区域 - 关键动画 */
.content {
  max-height: 0;
  overflow: hidden;
  opacity: 0;
  padding: 0 12px;
  color: #555;
  box-sizing: border-box;
  font-size: 14px;
  line-height: 1.6;
  transition: max-height 0.4s ease, opacity 0.3s ease, padding 0.3s ease;
}

.content.open {
  max-height: 200px; /* 必须 ≥ 最大内容高度 */
  opacity: 1;
  padding: 0px 12px 16px 32px;
}
.carousel {
  position: relative;
  overflow-x: hidden;
}

.carousel-inner {
  height: 100%;
  display: flex;
  transition: transform 0.5s ease;
}

.carousel-item {
  min-width: 100%;
  height: 100%;
}

.indicators {
  display: flex;
  justify-content: center;
}
.infoBox {
  margin-top: 24px;
  background-image: url("../../../static/userModelBg.png");
  background-size: 100% 100%;
  padding-top: 26px;
  box-sizing: border-box;
}
.infoBox1 {
  margin-top: 24px;
  padding-top: 26px;
  box-sizing: border-box;
  background: #fafcff;
}
.boxContent {
  width: 1200px;
  margin: 24px auto 0;
  padding-bottom: 24px;
  box-sizing: border-box;
}
.TitleBox {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 274px;
  box-sizing: border-box;
}
.titleItem {
  width: 145px;
  height: 39px;
  background: #e1e8ff;
  border-radius: 7px;
  text-align: center;
  line-height: 40px;
  color: #105fff;
  font-size: 12px;
  font-weight: 500;
}
.itemBox {
  width: 100%;
  margin-top: 24px;
}
.infoItem {
  display: flex;
  align-items: center;
  padding: 20px 30px;
  box-sizing: border-box;
  background: #ffffff;
  box-shadow: 0px 0px 4px 0px rgba(181, 181, 181, 0.5);
  border-radius: 12px;
  margin-bottom: 12px;
}
.infoItem img {
  width: 62px;
  height: 72px;
  margin-right: 20px;
}
.title1 {
  font-size: 16px;
  color: #000;
  font-weight: 600;
}
.info1 {
  font-size: 14px;
  color: #363b4d;
  margin-top: 12px;
}
</style>



// WEBPACK FOOTER //
// src/view/plan/plan.vue